import { useEffect } from "react";

export const usePageMeta = (title, description) => {
  useEffect(() => {
    document.title = `${title} | Clube Digital`;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
  }, [title, description]);
};
